// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Ma2S","modalForm":"UpgradeEpcsModal_modalForm__13yAC","modalFooter":"UpgradeEpcsModal_modalFooter__3bDir"};